import { useNavigate } from 'react-router-dom';
import { getPreview } from '../utils/helpers';
import { ACCENT_COLORS } from '../constants/config';

export default function BlogList({ blogs, showForm, setShowForm }) {
  const navigate = useNavigate();

  const openBlog = (blogId) => {
    navigate(`/blog/${blogId}`);
  };

  return (
    <section>
      <div className="mb-12">
        <h2 className="text-4xl font-bold mb-3">Latest Articles</h2>
        <p className="text-gray-400 text-lg">Insights and stories from my development journey</p>
      </div>

      {blogs.length === 0 ? (
        <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-16 text-center">
          <p className="text-gray-400 text-xl">No blog posts yet. Be the first to create one!</p>
          <button
            onClick={() => setShowForm(true)}
            className="mt-6 inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg font-semibold text-white hover:shadow-lg hover:shadow-purple-500/50 transition-all"
          >
            + Create Blog
          </button>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-2">
          {blogs.map((blog, index) => (
            <div
              key={blog.blogId}
              onClick={() => openBlog(blog.blogId)}
              className="group backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl overflow-hidden hover:border-white/30 transition-all duration-300 cursor-pointer hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/20"
            >
              {/* Card Header with accent */}
              <div className={`h-1 bg-gradient-to-r ${ACCENT_COLORS[index % ACCENT_COLORS.length]}`}></div>

              <div className="p-8">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-400 group-hover:to-purple-400 group-hover:bg-clip-text transition-all flex-1 pr-4">
                    {blog.title}
                  </h3>
                  <span className="px-4 py-1 bg-white/10 border border-white/20 rounded-full text-xs font-semibold text-gray-300 whitespace-nowrap">
                    Article
                  </span>
                </div>

                <p className="text-gray-400 text-base leading-relaxed mb-6 line-clamp-3">
                  {getPreview(blog.content)}
                </p>

                <div className="flex items-center justify-between pt-6 border-t border-white/10">
                  <span className="inline-flex items-center gap-2 text-sm font-semibold text-transparent bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text group-hover:gap-3 transition-all">
                    Read Full Article
                    <span className="text-lg">→</span>
                  </span>
                  <span className="text-xs text-gray-500">New</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
